import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      nav("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeSession(sid);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/interview", { replace: true, state: { user } });
      } catch {
        setErr("Could not establish the session. Try signing in again.");
      }
    })();
  }, [location.hash, nav]);

  return (
    <div className="flex h-full items-center justify-center" data-testid="auth-callback">
      <p className="label">{err || "Establishing session…"}</p>
    </div>
  );
}
